import {dhx4,dhx} from './dhx';
import  './dhx4.dateLang';

export {dhx4,dhx};



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/global/dhx4OrDhx/index.js